import {LiveImageDTO, LiveImage} from "../image";

export class NewsImageDTO extends LiveImageDTO {
  large: string;
}

export class NewsImage extends LiveImage {
  protected _large: string;

  get large(): string {
    return this.isSaved ? this._large : this.url;
  }

  constructor(data: NewsImageDTO) {
    super(data);
    this._large = data.large;
  }
}




// WEBPACK FOOTER //
// ./src/api/news/newsImage.ts